import React, { useState } from "react";
import {
  AllowanceBox,
  HeaderBorder,
  LeaveBody,
  LeaveTable,
  LeaveTableResponsive,
  LeaveTd,
  LeaveTh,
  LeaveThead,
  LeaveTr,
} from "../../../style";
import {
  Avatar,
  Box,
  Col,
  Dialog,
  Divider,
  Flex,
  Row,
  Typography,
  Button,
  InputField,
  SelectField,
  FabButton,
} from "../../../../ppui";

import GlobalTable from "../../../../components/global-table";
import { TbPlus, TbTrash } from "react-icons/tb";
import { headers } from "./employee-leave-data";
import useLeaveFormationService from "./leave-information-service";
import { LEAVE_INFORMATION_INITIAL } from "./leave-information-constant";
import { logger } from "../../../../utils/logger";

const EmpLeaveInformation = ({ openSnackbar }) => {
  const {
    leaveInformationLists,
    rowsPerPage,
    currentPage,
    totalPages,
    handleNextPage,
    handlePreviousPage,
    handleRowsPerPageChange,
    searchQuery,
    setSearchQuery,
    handleAddRow,
    handleDeleteRow,
    handleChange,
    leaveRequests,
    submitApplyLeave,
    getEmployeeLeaveInformation,
    setLeaveRequests,
    leaveListsInfo,
    EmployeeLeaveLists,
    // formattedFirstDayOfPreviousMonth
  } = useLeaveFormationService({ openSnackbar });

  logger.log(leaveRequests,"leaveRequests")
  const [LeaveInfoEdit, setLeaveInfoEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [leaveInfo, setLeaveInfo] = useState(null);


  const FetchDataFromRow = (row) => {
    setSelectedRow(row);
    getEmployeeLeaveInformation(row?.employee_id).then((data) => {
      setLeaveInfo(data);
      setLeaveInfoEdit(true);
    });
  };
  const LeaveInfoModalClose = () => setLeaveInfoEdit(false);

  // Apply-leave
  const [ApplyLeaveEdit, setApplyLeave] = React.useState(false);
  const ApplyLeaveModalOpen = () => {
    setLeaveRequests([
      { leave_type_id: "", start_date: "", end_date: "" },
    ]);
    setApplyLeave(true);
  }
  const ApplyLeaveModalClose = () => {
    setLeaveRequests(LEAVE_INFORMATION_INITIAL);
    setApplyLeave(false);
  };

  const handleApplyButtonSubmitFn = async (leaveRequests) => {
    const errors = [];
    let success = false;
    leaveRequests.forEach((request, index) => {
      const error = {};

      if (!request.leave_type_id) {
        error.leave_type_id = `Leave type is required for row ${index + 1}`;
      }
      if (!request.start_date) {
        error.start_date = `Start date is required for row ${index + 1}`;
      }
      if (!request.end_date) {
        error.end_date = `End date is required for row ${index + 1}`;
      }

      if (request.start_date && request.end_date && new Date(request.start_date) > new Date(request.end_date)) {
        error.date_range = `Start date cannot be after the end date for row ${index + 1}`;
      }

      if (Object.keys(error).length > 0) {
        errors.push(error);
      }
    });

    if (errors.length > 0) {
      openSnackbar({ message: "Please fill in all required fields correctly", color: "danger" });
      return;
    }

    success = await submitApplyLeave(leaveRequests, selectedRow?.employee_id);
    if (success) {
      setLeaveInfoEdit(false);
      setApplyLeave(false);
      setLeaveRequests(LEAVE_INFORMATION_INITIAL);
    } else {
      setApplyLeave(true);
    }
  };
  logger.log(leaveInfo,"leaveInfo")

  return (
    <>
      {/*=====Table-data=====*/}
        <GlobalTable
          headers={headers(currentPage, rowsPerPage)}
          rows={leaveInformationLists}
          ActiveSort={false}
          searchBox={true}
          columnManagement={true}
          avatar={true}
          rowsPerPage={rowsPerPage}
          currentPage={currentPage}
          totalPages={totalPages} // Pass total pages
          handleNextPage={handleNextPage} // Pass next page handler
          handlePreviousPage={handlePreviousPage} // Pass previous page handler
          handleRowsPerPageChange={handleRowsPerPageChange} // Pass rows-per-page handler
          FetchDataFromRow={FetchDataFromRow}
          stickyHeader="true"
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          actionLeft={
            <>
              <Typography variant="h5" mb="0">
               Employee leave Information
              </Typography>
            </>
          }
        />

      {/*=====Table-data=====*/}

      {/* Leave-InformationModal */}
      <Dialog
        title="Leave Information"
        closeButton={true}
        fullWidth
        maxWidth="md"
        buttonName={"Submit"}
        open={LeaveInfoEdit}
        onClose={LeaveInfoModalClose}
        onSubmit={() => alert("Submitted")}
        action={false}
        separator
        bodyScroll={true}
      >
        <Box Padding>
          <Row alignItem="center">
            <Col sm={12}>
              <Row alignItem="center">
                <Col sm={"auto"}>
                  <Avatar
                    size="lg"
                    initials={`${selectedRow?.first_name.trim().substring(0, 1).toUpperCase()}${selectedRow?.last_name.trim().substring(0, 1).toUpperCase()}`}
                    src={leaveInfo?.employee_image}
                  />
                </Col>
                <Col sm={3}>
                  <HeaderBorder>
                    <Typography variant="h6" mb={10}>
                      {`${selectedRow?.first_name} ${selectedRow?.last_name}`}
                    </Typography>
                    <Typography variant="body2">
                      #{selectedRow?.employee_code}
                    </Typography>
                  </HeaderBorder>
                </Col>
                <Col sm={2}>
                  <HeaderBorder>
                    <Typography variant="body1" mb={"0"}>
                      Department
                    </Typography>
                    <Typography variant="body2" mb={"0"}>
                      {selectedRow?.dept_name}
                    </Typography>
                  </HeaderBorder>
                </Col>
                <Col sm={2}>
                  <HeaderBorder>
                    <Typography variant="body1" mb={"0"}>
                      Designation
                    </Typography>
                    <Typography variant="body2" mb={"0"}>
                      {selectedRow?.designation_name}
                    </Typography>
                  </HeaderBorder>
                </Col>
                <Col sm={"auto"} ml={"auto"}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => {
                      ApplyLeaveModalOpen();
                      EmployeeLeaveLists(leaveInfo?.employment_type).then(() => {
                        // LeaveInfoModalClose();
                      })

                    }}
                  >
                    Apply Leave
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Box>
        <Divider gap={20} />
        <Flex gap={20} direction={"column"}>
          <AllowanceBox>
            <Row alignItems="center">
              <Col>
                <Flex
                  alignItems="center"
                  justifyContent="space-between"
                  gap={{ md: 20, lg: 40, xxl: 60 }}
                >
                  {Object.entries(leaveInfo?.leaveBalances || {}).map(([leaveType, usedLeaves]) => (
                    <Box key={leaveType}>
                      <Box className="label">{leaveType}</Box>
                      <Box className="value">{usedLeaves}</Box>
                    </Box>
                  ))}

                  <Box>
                    <Box className="label">Total Leave</Box>
                    <Box className="value">
                      {selectedRow?.total_leaves || 0}
                    </Box>
                  </Box>

                  <Box>
                    <Box className="label">Balance Leave</Box>
                    <Box className="value">
                      {selectedRow?.total_leaves - selectedRow?.used_leaves ||
                        0}
                    </Box>
                  </Box>
                </Flex>
              </Col>
            </Row>
          </AllowanceBox>
        </Flex>
        <Divider gap={20} />
        <LeaveTableResponsive>
          <LeaveTable>
            <LeaveThead>
              <LeaveTr>
                <LeaveTh rowspan="2">
                  <Typography m={"0"} variant="body2" strong>
                    Month Name
                  </Typography>
                </LeaveTh>
                <LeaveTh colspan={leaveInfo?.leaveTypes.length}>
                  <Typography m={"0"} variant="body2" strong align="center">
                    Used Leave
                  </Typography>
                </LeaveTh>
                <LeaveTh colspan="1" rowSpan="2">
                  <Typography m={"0"} variant="body2" strong align="center">
                    Sanction Leave
                  </Typography>
                </LeaveTh>
                <LeaveTh colspan="1" rowSpan="2">
                  <Typography m={"0"} variant="body2" strong>
                    LOP
                  </Typography>
                </LeaveTh>
              </LeaveTr>
              <LeaveTr>
                {leaveInfo?.leaveTypes.map((leaveType) => (
                  <LeaveTh key={leaveType}>
                    <Typography m={"0"} variant="body2" strong>
                      {leaveType}
                    </Typography>
                  </LeaveTh>
                ))}
              </LeaveTr>
            </LeaveThead>


            <LeaveBody>
              {leaveInfo?.usedLeaveSummary?.map((leave, index) => (
                <LeaveTr key={index}>
                  <LeaveTd>
                    <Typography m={"0"} variant="body2">
                      {new Date(0, leave.month - 1).toLocaleString("en-US", {
                        month: "long",
                      })}
                    </Typography>
                  </LeaveTd>
                  {Object.keys(leaveInfo.leaveBalances).map((leaveType) => (
                    <LeaveTd key={leaveType}>
                      <Typography m={"0"} variant="body2">
                        {leave[leaveType] || 0}
                      </Typography>
                    </LeaveTd>
                  ))}
                  <LeaveTd>
                    <Typography m={"0"} variant="body2">
                      {leave["Sanction Leave"] || 0}
                    </Typography>
                  </LeaveTd>
                  <LeaveTd>
                    <Typography m={"0"} variant="body2">
                      {leave.LOP || 0}
                    </Typography>
                  </LeaveTd>
                </LeaveTr>
              ))}

              <LeaveTr>
                <LeaveTd>
                  <Typography m={"0"} variant="body2" strong>
                    Total
                  </Typography>
                </LeaveTd>
                {Object.keys(leaveInfo?.leaveBalances || {}).map((leaveType) => (
                  <LeaveTd key={leaveType}>
                    <Typography m={"0"} variant="body2">
                      {leaveInfo?.usedLeaveSummary.reduce((acc, leave) => acc + (leave[leaveType] || 0), 0)}
                    </Typography>
                  </LeaveTd>
                ))}
                {["Sanction Leave", "LOP"].map((leaveKey) => (
                  <LeaveTd key={leaveKey}>
                    <Typography m={"0"} variant="body2">
                      {leaveInfo?.usedLeaveSummary.reduce((acc, leave) => acc + (leave[leaveKey] || 0), 0)}
                    </Typography>
                  </LeaveTd>
                ))}
              </LeaveTr>


              {/* <LeaveTr>
                <LeaveTd>
                  <Typography m={"0"} variant="body2" strong>
                    Total
                  </Typography>
                </LeaveTd>
                <LeaveTd>
                  <Typography m={"0"} variant="body2">
                    {leaveInfo?.usedLeaveSummary.reduce((acc, leave) => acc + leave.PL, 0)}
                  </Typography>
                </LeaveTd>
                <LeaveTd>
                  <Typography m={"0"} variant="body2">
                    {leaveInfo?.usedLeaveSummary.reduce((acc, leave) => acc + (leave.SL || 0), 0)}
                  </Typography>
                </LeaveTd>
                <LeaveTd>
                  <Typography m={"0"} variant="body2">
                    {leaveInfo?.usedLeaveSummary.reduce((acc, leave) => acc + leave.CL, 0)}
                  </Typography>
                </LeaveTd>
                <LeaveTd>
                  <Typography m={"0"} variant="body2">
                    {leaveInfo?.usedLeaveSummary.reduce(
                      (acc, leave) => acc + (leave["Sanction Leave"] || 0),
                      0
                    )}
                  </Typography>
                </LeaveTd>
                <LeaveTd>
                  <Typography m={"0"} variant="body2">
                    {leaveInfo?.usedLeaveSummary.reduce((acc, leave) => acc + (leave.LOP || 0), 0)}
                  </Typography>
                </LeaveTd>
              </LeaveTr> 

              {/* <LeaveTr>
                <LeaveTd>
                  <Typography m={"0"} variant="body2" strong>
                    Balance Leave
                  </Typography>
                </LeaveTd>

                <LeaveTd>
                  <Typography m={"0"} variant="body2">
                    11
                  </Typography>
                </LeaveTd>
                <LeaveTd>
                  <Typography m={"0"} variant="body2">
                    5
                  </Typography>
                </LeaveTd>
                <LeaveTd>
                  <Typography m={"0"} variant="body2">
                    6
                  </Typography>
                </LeaveTd>
                <LeaveTd>
                  <Typography m={"0"} variant="body2">
                    3
                  </Typography>
                </LeaveTd>
                <LeaveTd>
                  <Typography m={"0"} variant="body2">
                    2
                  </Typography>
                </LeaveTd>
              </LeaveTr> */}
            </LeaveBody>
          </LeaveTable>
        </LeaveTableResponsive>
      </Dialog>
      {/* Leave-InformationModal */}

      {/*Apply-leave-Modal*/}
      <Dialog
        title="Apply Leave"
        closeButton={true}
        fullWidth
        maxWidth="md"
        buttonName={"Submit"}
        open={ApplyLeaveEdit}
        onClose={ApplyLeaveModalClose}
        onSubmit={() => handleApplyButtonSubmitFn(leaveRequests)}
        separator
      >
        {leaveRequests?.map((item, index) => (
          <Row rowGap key={index} mb={20}>
            <Col sm={12} md={3}>
              <SelectField
                fullWidth
                required
                label="Leave Type"
                options={leaveListsInfo}
                placeholder="Select Here..."
                defaultValue={item?.leave_type_id}
                onChange={(e) =>
                  handleChange(index, "leave_type_id", e)
                }

              />
            </Col>

            <Col sm={12} md={3}>
              <InputField
                fullWidth
                required
                label="Start Date"
                type="Date"
                placeholder="Start Date"
                value={item.start_date}
                onChange={(e) =>
                  handleChange(index, "start_date", e.target.value)
                }
                valueSinc={"true"}
                // min={formattedFirstDayOfPreviousMonth}
                // min={
                //   leaveInfo?.join_date &&
                //   new Date(leaveInfo.join_date).getFullYear() === new Date().getFullYear() &&
                //   new Date(leaveInfo.join_date).getMonth() === new Date().getMonth()
                //     ? leaveInfo.join_date.split("T")[0] 
                //     : formattedFirstDayOfPreviousMonth
                // }
            
              />
            </Col>

            <Col sm={12} md={3}>
              <InputField
                fullWidth
                required
                label="End Date"
                type="Date"
                placeholder="End Date"
                value={item.end_date}
                onChange={(e) =>
                  handleChange(index, "end_date", e.target.value)
                }
                valueSinc={"true"}
                // min={
                //   item.start_date ||
                //   (leaveInfo?.join_date &&
                //   new Date(leaveInfo.join_date).getFullYear() === new Date().getFullYear() &&
                //   new Date(leaveInfo.join_date).getMonth() === new Date().getMonth()
                //     ? leaveInfo.join_date.split("T")[0] // Extract YYYY-MM-DD from ISO format
                //     : formattedFirstDayOfPreviousMonth)
                // }
              />
            </Col>

            <Col sm={"auto"}>
              <Flex gap={10}>
                {index === leaveRequests.length - 1 && (
                  <FabButton
                    color="primary"
                    icon={<TbPlus />}
                    onClick={handleAddRow}
                    shape="box"
                    variant="outlined"
                  />
                )}
                <FabButton
                  color="primary"
                  icon={<TbTrash />}
                  onClick={() => handleDeleteRow(index)}
                  shape="box"
                  variant="outlined"
                  disabled={leaveRequests.length === 1} // Prevent deleting if only one row exists
                />
              </Flex>
            </Col>
          </Row>
        ))}
      </Dialog>
      {/* Apply-leave-Modal */}
    </>
  );
};

export default EmpLeaveInformation;
